import { AdditionalRequirementType } from '~libs.shared.prescription';

import { AdditionalRequirement } from './additionalRequirements.types';

export const mapAdditionalRequirementsToRequirementTypes = (
   additionalRequirements: AdditionalRequirement[] | null
): AdditionalRequirementType[] => {
   if (!additionalRequirements) {
      return [];
   }

   return additionalRequirements.map(({ type }) => type);
};
